import * as React from 'react';

// REDUX
import { useAppSelector } from '../../store';

// COMPONENTS
import Button from '../../components/Button';
import SafeHtml from '../../components/SafeHtml';
import DownloadLink from '../../components/DownloadLink';
import DisplayDateTime from '../../components/DisplayDateTime';

// TYPES
import { ActivityFeedViewTypes, ViewTypes } from './ActivityFeedModal';

const ReadActivity: React.FC<ActivityFeedViewTypes> = ({ activity = {}, showView, closeModal }) => {
	const { canUpdate, title, date, userName, description, standards, attachments } = activity;

	const childSafeStandards = useAppSelector((state) => state.lists.childSafeStandards);

	const standardsMap = childSafeStandards?.filter(
		(item) => standards && standards.indexOf(item.value?.toLocaleLowerCase() || '') !== -1
	);

	// Check if Organisation is active
	const isOrganisationActive = useAppSelector((state) => state.user.isOrganisationActive);

	return (
		<article className="feed-article">
			<header>
				<h2 className="heading h4">{title}</h2>

				<time>
					<DisplayDateTime>{date}</DisplayDateTime>
				</time>
			</header>

			<section>
				<h3 className="subheading">Logged By</h3>

				<p>{userName}</p>
			</section>

			<section>
				<h3 className="subheading">Description of action taken</h3>
				{description ? <SafeHtml>{description}</SafeHtml> : <p>None</p>}
			</section>

			<section>
				<h3 className="subheading">Child Safe Standards supported</h3>

				{standardsMap && standardsMap.length > 0 ? (
					<ul className="traditional-list">
						{standardsMap.map((standard) => (
							<li key={standard.value}>{standard.label}</li>
						))}
					</ul>
				) : (
					<p>None</p>
				)}
			</section>

			<section>
				<h3 className="subheading">Attachments</h3>
				{attachments && attachments.length > 0 ? (
					<ul>
						{attachments.map((attachment, index) => (
							<li key={index}>
								<DownloadLink url={attachment.url} name={attachment.name} />
							</li>
						))}
					</ul>
				) : (
					<p>None</p>
				)}
			</section>

			{canUpdate && isOrganisationActive && (
				<section className="mtop-40">
					{canUpdate && (
						<Button className="btn-secondary w-100" onClick={() => showView(ViewTypes.Update)}>
							Edit
						</Button>
					)}
				</section>
			)}

			<section className="actions">
				<Button className="btn-primary full-width" onClick={closeModal}>
					Close
				</Button>
			</section>

			{canUpdate && isOrganisationActive && (
				<section className="top-40">
					<Button className="btn-text w-100" onClick={() => showView(ViewTypes.Delete)}>
						Delete activity
					</Button>
				</section>
			)}
		</article>
	);
};

export default ReadActivity;
